<template>
  <div class="caseprocess1 between">
    <div class="process1_item">
      <div><img src="~assets/case/xzls.png" /></div>
      <div>选择一名律师</div>
    </div>
    <div class="postm1"><img src="~assets/case/sredjt.png" alt=""> </div>
    <div class="process1_item">
      <div><img src="~assets/case/mswt.png" /></div>
      <div>描述您的问题</div>
    </div>
    <div class="postm1"><img src="~assets/case/sredjt.png" alt=""> </div>
    <div class="process1_item">
      <div><img src="~assets/case/srgt.png" /></div>
      <div>深入沟通</div>
    </div>
    <div class="postm1"><img src="~assets/case/sredjt.png" alt=""> </div>
    <div class="process1_item">
      <div><img src="~assets/case/wtjj.png" /></div>
      <div>问题解决</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.caseprocess1 {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 50px;
  .postm1{
      position: relative;
      top: -20px;
  }
  .process1_item {
    font-size: 20px;
    text-align: center;
    color: #1a1a1a;
    img {
      width: 100px;
      height: 100px;
      margin-bottom: 22px;
    }
  }
}
</style>